/**
 * Created by Administrator on 2017/9/6.
 */
import regex from '../common/regex';
import '../api/sso/url'
import '../api/base64'

export default {

  /**
   * 获取Url的参数
   * @param name 参数名
   * @returns {string|null}
   */
  getUrlKey: function (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
  },
  decodeBase64Params() {
    let urlParams = this.getUrlKey("v");
    let search = Base64.decode(urlParams).split("&");
    let params = {};
    let pos;
    let temp = "";

    for (let i=0; i < search.length; i++) {
      pos = search[i].indexOf("=");
      if (pos > 0) {
        temp = decodeURIComponent(search[i].substring(pos + 1));
        params[search[i].substring(0, pos)] = temp&&temp!=='undefined'?temp:'';
      }
    }
    return params;
  },
  encodeBase64Params(params, htmlName) {
    let urlParams = "";
    urlParams = (typeof params == 'string')?params:(()=>{
      let addArr = [];
      for(let i in params) {
        if(params.hasOwnProperty(i)) {
            addArr.push(i + "=" + encodeURIComponent(params[i]));
        }
      }
      return addArr.length>0?addArr.join('&'):'';
    })();
    return (htmlName||'')+(urlParams?'?v='+Base64.encode(urlParams):'');
  },
  cutShortBack: function (className, maxLength) {
    if (className == null || className == "")

      return;

    var nameAvgTotalLength = className.replace(/[^\x00-\xff]/g, "**").length;
    if (nameAvgTotalLength > maxLength) {
      let strName=className.substring(0,maxLength);

      className = strName + "...";
    }
    return className;
  },

  PlayBtAudio: function (audioUrl) {
    console.log("播放声音:", audioUrl);
    let audio = document.getElementById('audioPlayer');
    let biaojiCls = "biaoji-bofang-class"; // 标记a标签这个是播放声音的而不是其它的什么链接

    audio.src = audioUrl;
    let $Target = $(event.target);
    if ($Target.is("span") || $Target.is("i")) {
      // 如果用户点击的是图标，那么把target定位到父级的 a 标签
      $Target = $Target.closest("a");
    }
    $Target.addClass(biaojiCls);

    $("span.palybtn").removeClass("current");

    if (!$Target.hasClass("selected")) {
      if ($(".selected").length > 0) {
        $(".selected i").removeClass("icon-other-pauseround").addClass("icon-other-playround");
        $(".selected").removeClass("selected");
      }
      $Target.addClass('selected');
      $Target.find("i").removeClass("icon-other-playround").addClass("icon-other-pauseround");
      $Target.find("span.palybtn").addClass("current");
      audio.play();
    } else {
      $Target.find("i").removeClass("icon-other-pauseround").addClass("icon-other-playround");
      $Target.removeClass('selected');
      audio.pause();
    }

    let is_playFinish = setInterval(function () {
      if (audio.ended) {
        $(".selected").find("i").removeClass("icon-other-pauseround").addClass("icon-other-playround");
        $("span.palybtn").removeClass("current");
        $("a.selected." + biaojiCls).removeClass("selected"); // biaojiCls标记一下，防止把别的非播放组件的a标签的selected样式抹去了，毕竟这个selected在a标签上太常用了
        window.clearInterval(is_playFinish);
      }
    }, 1000);

  },

  PlayAudio: function (audioUrl) {
    console.log("播放声音:", audioUrl);
    let audio = document.getElementById('audioPlayer');

    audio.src = audioUrl;
    let $Target = $(event.target);
    if ($Target.is("span") || $Target.is("i")) {
      // 如果用户点击的是图标，那么把target定位到父级的 a 标签
      $Target = $Target.closest("a");
    }

    $("span.palybtn").removeClass("current");
    if (!$Target.hasClass("read-stop")) {//正在播放
      console.log(11111111);
      if ($(".selected").length > 0) {
        $(".selected").removeClass("read-stop");
        $(".selected").removeClass("selected");
      }
      $Target.addClass('selected');
      $Target.addClass("read-stop");
      $Target.addClass("current");
      audio.play();
    } else {
      console.log(222222222222);
      // $Target.find("i").removeClass("icon-other-pauseround").addClass("icon-other-playround");
      $Target.removeClass('selected');
      $Target.removeClass('read-stop');
      audio.pause();
    }

    let is_playFinish = setInterval(function () {
      if (audio.ended) {//录音结束
        $("a.selected").removeClass("read-stop");
        $("a.selected").removeClass("selected"); // biaojiCls标记一下，防止把别的非播放组件的a标签的selected样式抹去了，毕竟这个selected在a标签上太常用了
        window.clearInterval(is_playFinish);
      }
    }, 1000);

  },

  //处理填空题答案前后空格、大小写转换等
  stringRegex: function (str) {
    if (typeof (str) !== "string") {
      return str;
    }
    //统一中间空格
    str = str.replace(regex.centerSpace, ' ');
    //去除前后空格
    str = str.replace(regex.aroundSpace, '');
    //统一大小写
    return str.toLowerCase();
  },
  //处理注销、退出框居中
  initPosition: function () {
    var clientWidth = document.body.clientWidth;
    var popWidth = $('.popBox').width();

    var clientHeight = document.body.clientHeight;
    var popHeight = $('.popBox').height();

    $(".popBox").css({
      'left': (clientWidth - popWidth) / 2 + 'px',
      'top': (clientHeight - popHeight) / 2 + 'px'
    });
  },

  //处理保留个数,默认1位，其中0.0返回0,100.0返回100
  regexNumber: function (number, n) {
    if (!n) {
      n = 1;
    }
    if (typeof (number) != 'number' || typeof (n) != 'number') {
      return number;
    }
    let arr = number.toFixed(n).toString().split('.');
    if (arr.length <= 1) {
      return number;
    }
    if (regex.isAllZero.test(arr[1])) {
      return number.toFixed(n);
    }
    return arr[0];
  },
   templateCount:function (templateCode) {
  //templateCode  是数组  为标志  1为查所有的  2为查单个
     let  tem;
     let array=[];
     array= templateCode;
     if (typeof (templateCode)!='array'){

     }
     array.forEach(function ( item)   {
       switch (item){
         case  'PassageReading':
         case  'PassageReadingA':tem+=120;break ;
         case 'SituationalVideoPresentation':tem+=120;break ;
         default :tem+=60;break;
       }
})
  return tem;
   },

  /*
   * 字符串省略显示，中间显示“...”
   */
  cutShort: function (className, maxLength) {
    if (className == null || className == "")
      return;
    var nameAvgTotalLength = className.replace(/[^\x00-\xff]/g, "**").length;
    if (nameAvgTotalLength > maxLength) {
      var newClassName = "";
      var newClassBackName = "";
      var nameLength = className.length;
      var totalLength = 0;
      var avgLength = maxLength / 2;
      nameAvgTotalLength -= avgLength;
      var classNameList = className.split("");
      for (var i = 0; i < nameLength; i++) {
        var cName = classNameList[i];
        if (/^[\u4e00-\u9fa5（）]$/.test(cName)) {
          totalLength += 2;
        }
        else {
          totalLength += 1;
        }
        if (totalLength <= avgLength || totalLength > nameAvgTotalLength) {
          if (totalLength <= avgLength)
            newClassName += cName;
          else
            newClassBackName += cName;
        }
      }
      className = newClassName + "..." + newClassBackName;
    }
    return className;
  },

  /*
   * 字符串省略显示，中间显示“...”
   */
  cutShortBack: function (className, maxLength) {
    if (className == null || className == "")
      return;
    var nameAvgTotalLength = className.replace(/[^\x00-\xff]/g, "**").length;
    if (nameAvgTotalLength > maxLength) {
      let strName=className.substring(0,maxLength-3);

      className = strName + "...";
    }
    return className;
  },
  //名称格式
  strSlic: function (str, n) {
    if(str==''||str==null){
      return null;
    }
    const r = /[^\x00-\xff]/g;
    if (str.replace(r, "mm").length <= n) {
      return str;
    }
    if(str.length<=n-3){
      return str;
    }
    var m = Math.floor(n / 2);
    for (var i = m; i < str.length+1; i++) {
      if (str.substr(0, i).replace(r, "mm").length >= n) {
        return str.substr(0, i) + "..." ;
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/utils/utils.js